import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const CashFlowTransactionsFilter = ({ isFiltering, onFilter }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen]     = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate]     = useState('');
    const queryClient = useQueryClient();

    const activeCount = [startDate, endDate].filter(Boolean).length;

    const handleFilter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onFilter([startDate ?? '', endDate ?? '']);
    };

    const handleReset = () => {
        setStartDate('');
        setEndDate('');
        onFilter(['', '']);
        queryClient.invalidateQueries(['cashflow-transactions', 'paginated']);
    };

    return (
        <>
            <button type="button" className={`filter-toggle${isOpen ? ' on' : ''}`} onClick={() => setIsOpen(o => !o)}>
                <FilterIcon /> {t('cashflow.filters')}
                {activeCount > 0 && <span className="cnt">{activeCount}</span>}
                <ChevIcon />
            </button>

            {isOpen && (
                <Form onSubmit={handleFilter} className="filter-panel">
                    <div className="filter-grid">
                        <DatePicker
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            className="form-control"
                            label={t('cashflow.dateFrom')}
                            placeholderText={t('cashflow.monthYear')}
                            selected={startDate}
                            onChange={setStartDate}
                            maxDate={endDate || undefined}
                        />
                        <DatePicker
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            className="form-control"
                            label={t('cashflow.dateTo')}
                            placeholderText={t('cashflow.monthYear')}
                            selected={endDate}
                            onChange={setEndDate}
                            minDate={startDate || undefined}
                        />
                    </div>

                    <div className="filter-foot">
                        <span className="meta">
                            {activeCount > 0 ? (activeCount === 1 ? t('cashflow.filterSelected') : t('cashflow.filtersSelected', { count: activeCount })) : t('cashflow.noFiltersApplied')}
                        </span>
                        <div className="sp">
                            <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={handleReset}>{t('cashflow.reset')}</button>
                            <button type="submit" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isFiltering}>
                                {isFiltering ? t('cashflow.filtering') : t('cashflow.applyFilters')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </>
    );
};

export default CashFlowTransactionsFilter;
